import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

import StandardSection from '../c/StandardSection/StandardSection'

const breakpoints = [440, 768, 1024, 1200, 1400];
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`));

const wrapMQ = css(mq({
  paddingTop: [
    32, // 0+
    32, // 440+
    80, // 768+
    80, // 1024+
    80, // 1200+
    132, // 1400+
  ],
}))

export const Wrap = styled(StandardSection)`
  ${wrapMQ}
`

const contentMQ = css(mq({
  gap: [
    32, // 0+
    32, // 440+
    80, // 768+
    80, // 1024+
    80, // 1200+
    72, // 1400+
  ],
}))

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  ${contentMQ}
`

const titleCustomersWrapMQ = css(mq({
  display: [
    "flex", // 0+
    "flex", // 440+
    "flex", // 768+
    "flex", // 1024+
    "flex", // 1200+
    "grid", // 1400+
  ],
  flexDirection: [
    "column", // 0+
    "column", // 440+
    "column", // 768+
    "column", // 1024+
    "column", // 1200+
    "none", // 1400+
  ],
  gridTemplateColumns: [
    "none", // 0+
    "none", // 440+
    "none", // 768+
    "none", // 1024+
    "none", // 1200+
    "minmax(580px, 1fr) 1fr", // 1400+
  ],
}))

export const TitleCustomersWrap = styled.div`
  display: grid;
  gap: 32px;
  ${titleCustomersWrapMQ}
`

const titleMQ = css(mq({
  font: [
    "var(--accent-770)", // 0+
    "var(--accent-770)", // 440+
    "var(--accent-970)", // 768+
    "var(--accent-1070)", // 1024+
  ],
}))

export const Title = styled.h2`
  color: var(--color-grayscale-900);

  & > ins {
    color: var(--color-branding);
    text-decoration: none;
  }
  ${titleMQ}
`

const customersWrapMQ = css(mq({
  gap: [
    16, // 0+
    16, // 440+
    16, // 768+
    16, // 1024+
    16, // 1200+
    18, // 1400+
  ],
}))

export const CustomersWrap = styled.div`
  display: flex;
  flex-direction: column;
  ${customersWrapMQ}
`

const customersTitleMQ = css(mq({
  font: [
    "var(--text-640)", // 0+
    "var(--text-640)", // 440+
    "var(--text-640)", // 768+
    "var(--text-740)", // 1024+
    "var(--text-740)", // 1200+
    "var(--text-540)", // 1400+
  ],
  textAlign: [
    "left", // 0+
    "left", // 440+
    "left", // 768+
    "left", // 1024+
    "left", // 1200+
    "right", // 1400+
  ],
}))

export const CustomersTitle = styled.div`
  color: var(--color-grayscale-900);
  ${customersTitleMQ}
`

const customersGridMQ = css(mq({
  gridTemplateColumns: [
    "repeat(auto-fit, minmax(172px, 1fr))", // 0+
    "repeat(auto-fit, minmax(172px, 1fr))", // 440+
    "repeat(auto-fit, minmax(220px, 1fr))", // 768+
    "repeat(auto-fit, minmax(300px, 1fr))", // 1024+
    "repeat(auto-fit, minmax(170px, 1fr))", // 1200+
    "repeat(3, minmax(152px, 1fr))", // 1400+
  ],
  gap: [
    20, // 0+
    20, // 440+
    20, // 768+
    20, // 1024+
    20, // 1200+
    15, // 1400+
  ],
}))

export const CustomersGrid = styled.div`
  display: grid;
  ${customersGridMQ}
`

export const CustomerCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: var(--color-grayscale-37);
  height: 72px;
`

const mqValues = facepaint([440, 576, 768, 1400].map(bp => `@media (min-width: ${bp}px)`));

const valuesWrapMQ = css(mqValues({
  gridTemplateColumns: [
    "repeat(auto-fit, minmax(162px, 1fr))", // 0+
    "repeat(auto-fit, minmax(180px, 1fr))", // 440+
    "repeat(auto-fit, minmax(240px, 1fr))", // 576+
    "repeat(auto-fit, minmax(160px, 1fr))", // 786+
  ],
  gap: [
    12, // 0+
    12, // 440+
    12, // 576+
    12, // 768+
    32, // 1400+
  ],
}))
export const ValuesWrap = styled.div`
  display: grid;
  ${valuesWrapMQ}
`

const valueBlock = ({ gap }) => {
  return css({
    gap: gap,
  })
}

export const ValueBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  padding: 16px;
  border-radius: 20px;
  border: 1px solid var(--color-grayscale-50);
  outline-style: solid;
  outline-width: 1px;
  outline-offset: -9px;
  outline-color: var(--color-grayscale-100);

  ${valueBlock}
`

export const ValueImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  flex-shrink: 0;

  & > img {
    max-width: 80%;
    height: auto;
  }

`

export const ValueText = styled.div`
  font: var(--text-540);
  color: var(--color-grayscale-900);
  text-align: center;
`
